<template>
  <div class="main-wrapper">
    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox" style="padding-bottom: 0px">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span
                      class="font-weight-600 text-slate-300"
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
              </div>
            </div>

            <!-- Success Icon -->
            <div class="text-center mb-4">
              <div
                class="success-icon-container"
                :style="{ backgroundColor: branding.primaryColor + '15' }"
              >
                <i
                  class="fa fa-check-circle"
                  :style="{ color: branding.primaryColor, fontSize: '48px' }"
                ></i>
              </div>
            </div>

            <div class="login-header text-center">
              <h5 class="mb-3" style="font-weight: 600; color: #333;">
                {{
                  isExistingUser
                    ? "Account Found!"
                    : "Account Created Successfully!"
                }}
              </h5>

              <!-- Business Name Badge -->
              <div v-if="businessName" class="mb-3">
                <span
                  class="badge badge-success-light"
                  :style="{
                    backgroundColor: branding.primaryColor + '20',
                    color: branding.primaryColor,
                    padding: '8px 16px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }"
                >
                  {{ businessName }}
                </span>
              </div>

              <!-- Description -->
              <p class="text-muted" style="line-height: 1.6;">
                <template v-if="isExistingUser">
                  We found an existing account associated with this invitation.
                  Please login with your password to continue.
                </template>
                <template v-else>
                  Your account has been created and your invitation has been
                  accepted. You can now login to access your account.
                </template>
              </p>

              <!-- Email Display -->
              <div v-if="email" class="email-display mt-3 mb-4">
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="
                    background-color: #f5f5f5;
                    padding: 10px 16px;
                    border-radius: 8px;
                    display: inline-flex;
                  "
                >
                  <i class="fa fa-envelope text-muted mr-2"></i>
                  <span style="color: #555; font-weight: 500;">{{
                    email
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Login Button -->
            <div class="text-center mt-4">
              <button
                class="btn btn-primary btn-block account-btn"
                type="button"
                @click="goToLogin()"
                :style="{
                  backgroundColor: branding.buttonColor,
                  color: branding.buttonTextColor,
                  borderColor: branding.buttonColor
                }"
              >
                Go to Login
              </button>
            </div>

            <div
              class="text-center dont-have mb-4"
              style="margin-top: 1.5rem !important;"
            >
              <div class="mt-3">
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }}
                  <a
                    :href="branding.privacyPolicyUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a>
                  and
                  <a
                    :href="branding.termsUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a>
                  that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandingByDomain } from "@/config/domainBranding";

export default {
  name: "InvitationSuccess",
  data() {
    return {
      businessName: "",
      email: "",
      isExistingUser: false,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || "#ffffff",
        fontWeight: "bold",
        backgroundColor:
          this.branding.logo.suffixBackgroundColor ||
          this.branding.primaryColor,
        padding: "6px",
        borderRadius: "5px"
      };
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      };
    }
  },
  methods: {
    goToLogin() {
      this.$router.push("/login");
    }
  },
  mounted() {
    // Get data from query params
    this.businessName = this.$route.query.businessName || "";
    this.email = this.$route.query.email || "";
    this.isExistingUser = this.$route.query.isExistingUser === "true";

    // Clear session storage
    sessionStorage.removeItem("invitationData");
  }
};
</script>

<style scoped>
.success-icon-container {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.email-display {
  display: flex;
  justify-content: center;
}

.badge-success-light {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/InvitationSuccess.vue